// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: true,
  apiUrl: 'https://penn-de.salesonepro.com/api/e',
  authUrl: 'https://penn-de.salesonepro.com/signin',
  socketUrl: 'wss://penn-de.salesonepro.com',
  clientId: 'P7K1ySH4KyTurv4PmTzzrbX3bdr82krV6grbrJQx',
  clientSecret: 'cJnit4TjlOy33EjaadfMW1bnZllWYPm186l3TilUCvenz0K2VwAOVkXItosXFQ5SfOOIWc8AOrD9JttTJY4eebu43PrprJkPcVpGYF0JZosxuT1SnRMFJlbQN0aUdCEt',
  tableRowLimit: '15',
  sanmarTrackingUrl: 'https://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=',
  rocketShipServerUrl: 'https://printserver.local:8081',
  printSocketUrl: 'wss://printserver.salesonepro.com:8887',
  brotherProfile: 'CO12',
  brotherPrinterVersion: [3, 4],
  printSocketKey: 'BD6F38FA9C8EE9386ABEDD725A4B1F05F4E74866517BFE46A7C81A71AF42697D'
};
